import http from 'conversations-http/clients/http';
export const disassociateContactClient = ({
  threadId
}) => http.delete(`/messages/v2/associations/contact/thread/${threadId}`);